import {Component} from "@angular/core";
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'inbound-configuration-tabs',
	templateUrl: './threat-response-tabs.component.html',
})
export class ThreatResponseTabsComponent extends TabsPageContainer {
	tabWidth = 170;
}
